import { Survey } from 'types/survey';
import { useAuthentication } from './useAuthentication';

export const useSurveyTranslation = (surveyDefinition: Survey | undefined) => {
  const { user } = useAuthentication();
  return (key: string) => {
    const locale = user?.locale;
    if (!locale || !surveyDefinition?.localizations[locale]) {
      return key;
    }
    return surveyDefinition.localizations[locale][key] || key;
  };
};
